import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from "../services/language.service";

@Pipe({
  name: 'messageDate',
  pure: true
})
export class MessageDatePipe implements PipeTransform {

  private readonly currentDate = new Date();

  private readonly timezone = `UTC+${
    (this.currentDate.getTimezoneOffset() / 60) * -1
  }`;

  constructor(private datePipe: DatePipe,
              private languageService: LanguageService) {
  }

  transform(
    value: string,
    format: string = 'yyyy-MM-dd HH:mm:ss',
    timezone: string = this.timezone,
    locale: string = this.languageService.currentLang
  ): string | undefined | null {

    const messageDate = new Date(value);

    if (this.currentDate.getUTCFullYear() !== messageDate.getUTCFullYear()) {
      format = 'yyyy MMM dd HH:mm';
    } else if (this.currentDate.getUTCMonth() !== messageDate.getUTCMonth()) {
      format = 'MMM d';
    } else if (this.currentDate.getUTCDate() !== messageDate.getUTCDate()) {
      format = 'H:mm';
    }

    return this.datePipe.transform(value, format, timezone, locale);
  }
}
